import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div>
            <div className="loader">
                <div className="circle1"></div>
                <div className="circle2"></div>
                <div className="circle3"></div>
            </div>
        </div>
    )
}

export default Loading
